import { createContext as e, useContext as n } from "react";
const o = e(null);
function u() {
  const t = n(o);
  if (!t)
    throw new Error("useInputSystem must be used within InputSystemProvider");
  return t;
}
export {
  o as InputSystemContext,
  u as useInternalInputSystem
};
